export default {
    DELETE: "DELETE", //Requests that a specified URI be deleted.
    GET: "GET", //Retrieves the information or entity that is identified by the URI of the request.
    HEAD: "HEAD", //Retrieves the message headers for the information or entity that is identified by the URI of the request.
    OPTIONS: "OPTIONS", //Represents a request for information about the communication options available on the request/response chain identified by the Request-URI.
    PATCH: "PATCH", //Requests that a set of changes described in the request entity be applied to the resource identified by the Request- URI.
    POST: "POST", //Posts a new entity as an addition to a URI.
    PUT: "PUT" //Replaces an entity that is identified by a URI.
};
